isHubsAncientWisdom